export default [
  {
    path: "/citizens",
    name: "citizens",
    component: () =>
      import(
        /* webpackChunkName: "citizens" */ "@/views/citizens/CitizensView.vue"
      ),
    meta: { activeIcon: "Citizens", routeName: "Citizens" },
  },
  {
    path: "/citizens/register",
    name: "register-citizen",
    component: () =>
      import(
        /* webpackChunkName: "citizens" */ "@/views/citizens/CitizenFormView.vue"
      ),
    props: {
      action: "create",
    },
    meta: { activeIcon: "Citizens", routeName: "Register" },
  },
  {
    path: "/citizens/:id/edit",
    name: "edit-citizen",
    component: () =>
      import(
        /* webpackChunkName: "citizens" */ "@/views/citizens/CitizenFormView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
      action: "update",
    }),
    meta: {
      activeIcon: "Citizens",
      routeName: "Edit Citizen",
    },
  },
  {
    path: "/citizens/:id",
    name: "citizen-details",
    component: () =>
      import(
        /* webpackChunkName: "citizens" */ "@/views/citizens/CitizenDetailsView.vue"
      ),
    props: (route) => ({ id: String(route.params.id) }),
    meta: {
      activeIcon: "Citizens",
      routeName: "Citizen Details",
    },
  },
  {
    path: "/citizens/:id/vaxcert",
    name: "citizen-vaxcert-file-view",
    component: () =>
      import(/* webpackChunkName: "citizens" */ "@/views/FileView.vue"),
    props: (route) => ({ id: String(route.params.id), type: "vaxcert" }),
    meta: {
      activeIcon: "Citizens",
      routeName: "Citizen VaxCert",
    },
  },

  // CITIZENS' SERVICES

  // CONSULTATIONS
  {
    path: "/citizens-consultations",
    name: "citizens-consultations",
    component: () =>
      import(
        /* webpackChunkName: "citizen-admin" */ "@/views/consultations/ConsultationsView.vue"
      ),
    props: true,
    meta: {
      activeIcon: "Consultations",
      routeName: "Citizens' Consultations",
    },
  },
  {
    path: "/citizens-consultations/:consultation_id/view/:hospital_service_id",
    name: "citizens-consultations-view",
    component: () =>
      import(
        /* webpackChunkName: "citizen-admin" */ "@/views/consultations/ConsultationInformationView.vue"
      ),
    props: (route) => ({
      consultation_id: String(route.params.consultation_id),
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "Consultations",
      routeName: "Citizen Consultation Details",
    },
  },
  {
    path: "/citizens-consultations/:consultation_id/view/:hospital_service_id/form/:consultation_form_id",
    name: "citizens-edit-consultation-form",
    component: () =>
      import(
        /* webpackChunkName: "citizen-admin" */ "@/views/consultations/form/ConsultationFormView.vue"
      ),
    props: (route) => ({
      consultation_id: String(route.params.consultation_id),
      hospital_service_id: String(route.params.hospital_service_id),
      consultation_form_id: String(route.params.consultation_form_id),
      userRole: "ROOT",
      action: "edit",
    }),
    meta: {
      activeIcon: "Consultations",
      routeName: "Edit Consultation Form",
    },
  },
  {
    path: "/citizens-consultations/:consultation_id/view/:hospital_service_id/form/:consultation_form_id/continuation",
    name: "citizens-edit-consultation-form-continuation",
    component: () =>
      import(
        /* webpackChunkName: "citizen-admin" */ "@/views/consultations/form/ConsultationFormContinuation.vue"
      ),
    props: (route) => ({
      consultation_id: String(route.params.consultation_id),
      hospital_service_id: String(route.params.hospital_service_id),
      consultation_form_id: String(route.params.consultation_form_id),
      userRole: "ROOT",
      action: "edit",
    }),
    meta: {
      activeIcon: "Consultations",
      routeName: "Edit Consultation Form",
    },
  },
  {
    path: "/citizens-consultations/:consultation_id/view/:hospital_service_id/form",
    name: "citizens-add-consultation-form",
    component: () =>
      import(
        /* webpackChunkName: "doctor-consultations" */ "@/views/consultations/form/ConsultationFormView.vue"
      ),
    props: (route) => ({
      consultation_id: String(route.params.consultation_id),
      hospital_service_id: String(route.params.hospital_service_id),
      userRole: "ROOT",
      action: "add",
    }),
    meta: {
      activeIcon: "Consultations",
      routeName: "Add Consultation Form",
    },
  },
  {
    path: "/citizens-consultations/:consultation_id/view/:hospital_service_id/form/2",
    name: "citizens-add-consultation-form-continuation",
    component: () =>
      import(
        /* webpackChunkName: "doctor-consultations" */ "@/views/consultations/form/ConsultationFormContinuation.vue"
      ),
    props: (route) => ({
      consultation_id: String(route.params.consultation_id),
      hospital_service_id: String(route.params.hospital_service_id),
      userRole: "ROOT",
      action: "add",
    }),
    meta: {
      activeIcon: "Consultations",
      routeName: "Add Consultation Form",
    },
  },
  {
    path: "/citizens-consultations/:consultation_id/view/:hospital_service_id/files",
    name: "citizens-consultation-files",
    component: () =>
      import(
        /* webpackChunkName: "doctor-consultations" */ "@/views/consultations/ConsultationFilesView.vue"
      ),
    props: (route) => ({
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "Consultations",
      routeName: "Consultation Files",
    },
  },
  {
    path: "/citizens-consultations/:consultation_id/view/:hospital_service_id/files/viewer",
    name: "citizens-consultation-files-view",
    component: () =>
      import(
        /* webpackChunkName: "doctor-consultations" */ "@/views/FileView.vue"
      ),
    props: (route) => ({
      consultation_id: String(route.params.consultation_id),
      hospital_service_id: String(route.params.hospital_service_id),
      type: "hospital-service",
    }),
    meta: {
      activeIcon: "Consultations",
      routeName: "Consultation File Viewer",
    },
  },

  // DIALYSIS
  {
    path: "/citizens-dialysis",
    name: "citizens-dialysis",
    component: () => import("@/views/dialysis/DialysisView.vue"),
    meta: {
      activeIcon: "Dialysis",
      routeName: "Citizens' Dialysis",
    },
  },
  {
    path: "/citizens-dialysis/session/:id",
    name: "citizens-dialysis-session",
    component: () =>
      import(
        /* webpackChunkName: "dialysis" */ "@/views/dialysis/DialysisSessionView.vue"
      ),
    props: true,
    meta: {
      activeIcon: "Dialysis",
      routeName: "Citizens's Dialysis Session",
    },
  },
  {
    path: "/citizens-dialysis/session/:id/files/:hospital_service_id",
    name: "citizens-dialysis-files",
    component: () =>
      import(
        /* webpackChunkName: "dialysis" */ "@/views/dialysis/DialysisFilesView.vue"
      ),
    props: (route) => ({
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "Dialysis",
      routeName: "Citizens's Dialysis Session Files",
    },
  },
  {
    path: "/citizens-dialysis/session/:id/files/:hospital_service_id/viewer",
    name: "citizens-dialysis-files-view",
    component: () =>
      import(/* webpackChunkName: "dialysis" */ "@/views/FileView.vue"),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
      type: "hospital-service",
    }),
    meta: {
      activeIcon: "Dialysis",
      routeName: "Dialysis Session File Viewer",
    },
  },

  // DIAGNOSTICS
  {
    path: "/citizens-diagnostics",
    name: "citizens-diagnostics",
    component: () => import("@/views/diagnostics/DiagnosticsView.vue"),
    meta: {
      activeIcon: "Diagnostics",
      routeName: "Citizens' Diagnostics",
    },
  },
  {
    path: "/citizens-diagnostics/:id",
    name: "citizens-diagnostic-details",
    component: () =>
      import(
        /* webpackChunkName: "diagnostics" */ "@/views/diagnostics/DiagnosticInformationView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
    }),
    meta: {
      activeIcon: "Diagnostics",
      routeName: "Citizen's Diagnostic Information",
    },
  },
  {
    path: "/citizens-diagnostics/:id/files/:hospital_service_id",
    name: "citizens-diagnostic-files",
    component: () =>
      import(
        /* webpackChunkName: "diagnostics" */ "@/views/diagnostics/DiagnosticFilesView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "Diagnostics",
      routeName: "Citizen's Diagnostic Files",
    },
  },
  {
    path: "/citizens-diagnostics/:id/files/:hospital_service_id/viewer",
    name: "citizens-diagnostic-files-view",
    component: () =>
      import(/* webpackChunkName: "dialysis" */ "@/views/FileView.vue"),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
      type: "hospital-service",
    }),
    meta: {
      activeIcon: "Diagnostics",
      routeName: "Diagnostic File Viewer",
    },
  },

  // LABORATORIES
  {
    path: "/citizens-laboratories",
    name: "citizens-laboratories",
    component: () => import("@/views/laboratories/LaboratoriesView.vue"),
    meta: {
      activeIcon: "Laboratories",
      routeName: "Citizens' Laboratories",
    },
  },
  {
    path: "/citizens-laboratories/:id",
    name: "citizens-laboratory-details",
    component: () =>
      import(
        /* webpackChunkName: "laboratories" */ "@/views/laboratories/LaboratoryInformationView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
    }),
    meta: {
      activeIcon: "Laboratories",
      routeName: "Citizen's Laboratory",
    },
  },
  {
    path: "/citizens-laboratories/:id/files/:hospital_service_id",
    name: "citizens-laboratory-files",
    component: () =>
      import(
        /* webpackChunkName: "laboratories" */ "@/views/laboratories/LaboratoryFilesView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "Laboratories",
      routeName: "Citizen's Laboratory Files",
    },
  },
  {
    path: "/citizens-laboratories/:id/files/:hospital_service_id/viewer",
    name: "citizens-laboratory-files-view",
    component: () =>
      import(/* webpackChunkName: "dialysis" */ "@/views/FileView.vue"),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
      type: "hospital-service",
    }),
    meta: {
      activeIcon: "Laboratories",
      routeName: "Laboratory File Viewer",
    },
  },

  // GENERAL SERVICES
  {
    path: "/citizens-general-services",
    name: "citizens-general-services",
    component: () => import("@/views/general-services/GeneralServicesView.vue"),
    meta: {
      activeIcon: "General Services",
      routeName: "Citizens' General Services",
    },
  },
  {
    path: "/citizens-general-services/:id",
    name: "citizens-general-services-details",
    component: () =>
      import(
        /* webpackChunkName: "laboratories" */ "@/views/general-services/GeneralServiceInformationView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
    }),
    meta: {
      activeIcon: "General Services",
      routeName: "Citizen's General Service",
    },
  },
  {
    path: "/citizens-general-services/:id/files/:hospital_service_id",
    name: "citizens-general-services-files",
    component: () =>
      import(
        /* webpackChunkName: "laboratories" */ "@/views/general-services/GeneralServiceFilesView.vue"
      ),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
    }),
    meta: {
      activeIcon: "General Services",
      routeName: "Citizen's General Service Files",
    },
  },
  {
    path: "/citizens-general-services/:id/files/:hospital_service_id/viewer",
    name: "citizens-general-services-files-view",
    component: () =>
      import(/* webpackChunkName: "dialysis" */ "@/views/FileView.vue"),
    props: (route) => ({
      id: String(route.params.id),
      hospital_service_id: String(route.params.hospital_service_id),
      type: "hospital-service",
    }),
    meta: {
      activeIcon: "General Services",
      routeName: "General Service File Viewer",
    },
  },
];
